import { Dialog } from 'vant'
import { THEME_COLOR } from '@/defines/environment/config'

export const DialogAlert = (message, options) => {
  const config = {
    confirmButtonColor: THEME_COLOR,
    ...options
  }
  return Dialog.alert({
    message,
    ...config
  })
}
